import { useCallback, useRef } from "react";
import { useGoogleMaps } from "../../common/GoogleMapsContext";
import { GoogleMap, MarkerF } from "@react-google-maps/api";

const mapContainerStyle = {
  width: "100%",
  height: "400px",
};
const MAP_ZOOM_LEVEL_FOR_PIN_DROP = 15;

export const setMarkerMappingPosition = async (form, lat, lng, setMarkerPosition, setGeocodingLoading, setSelectedAddress, markerPlacedRef) => {
  setMarkerPosition({ lat, lng });
  markerPlacedRef.current = true; // Mark that the user has placed a marker

  setSelectedAddress(true)
  // Set form values
  form.setFieldValue('mapLat', lat);
  form.setFieldValue('mapLng', lng);
  form.setFieldValue('acceptDeclaration', false);
  form.setFieldError("mapLat", undefined);
  // form.setFieldError("enterAlbertaAddress", undefined);
}

const MapViewer = (input) => {
  const {form, context, disabled} = input
      
  return (
    <>
      <MapMarker form={form}
        mapPosition={{lat: context?.EvacuationLocation?.mapLat ?? 53.5461, lng: context?.EvacuationLocation?.mapLng ?? -113.4938}} 
        markerPosition={{lat: context?.EvacuationLocation?.mapLat, lng: context?.EvacuationLocation?.mapLng}} 
        disabled={disabled}
      />
    </>
  )
}

export const MapMarker = ({ form, mapPosition, markerPosition, setMarkerPosition, disabled, setGeocodingLoading, setMapInstance, setSelectedAddress }) => {
    
  const { isLoaded } = useGoogleMaps();

  const mapRef = useRef(null);
  const markerPlacedRef = useRef(false);
  const initialZoomRef = useRef(null);

  const applyMapTypeForZoom = useCallback(() => {
    const map = mapRef.current;
    if (!map) return;

    const zoom = map.getZoom() ?? 0;

    if (initialZoomRef.current == null) {
      initialZoomRef.current = zoom;
    }

    const desiredType =
      zoom > initialZoomRef.current || markerPlacedRef.current
        ? "hybrid"
        : "roadmap";

    if (map.getMapTypeId() !== desiredType) {
      map.setMapTypeId(desiredType);
    }
  }, []);

  const handleMapClick = useCallback((event) => {
      if (disabled || !event.latLng || !mapRef.current) return;

      const map = mapRef.current;
      const currentZoom = map.getZoom();

      // 2. LEGACY LOGIC: Check Zoom Level
      if (currentZoom < MAP_ZOOM_LEVEL_FOR_PIN_DROP) {
          // Logic: Zoom in by 3 levels, but don't go past the threshold
          let newZoom = currentZoom + 3;
          if (newZoom > MAP_ZOOM_LEVEL_FOR_PIN_DROP) {
              newZoom = MAP_ZOOM_LEVEL_FOR_PIN_DROP;
          }
          
          // Perform the Zoom and Pan
          map.setZoom(newZoom);
          map.panTo(event.latLng);
          // DO NOT drop the pin yet
      } 
      else {
          // 3. Zoom is high enough -> Allow Pin Drop
          setMarkerMappingPosition(form, event.latLng.lat(), event.latLng.lng(), setMarkerPosition, setGeocodingLoading, setSelectedAddress, markerPlacedRef);
      }
  }, [disabled, form, setMarkerPosition, setGeocodingLoading, setSelectedAddress]);

  if(!isLoaded) return <div>Loading...</div>;
  
  return (
    <>
      <GoogleMap id="googleMap"
        mapContainerStyle={mapContainerStyle}
        zoom={10}
        center={mapPosition}
        onClick={disabled ? undefined : handleMapClick}
        onZoomChanged={applyMapTypeForZoom}
        onIdle={applyMapTypeForZoom}
        options={{
          streetViewControl: false,
          mapTypeControl: false,
        }}
        onLoad={(map) => {
            mapRef.current = map; // Save for local click handler
            initialZoomRef.current = map.getZoom() ?? 10;
            
            map.setMapTypeId("roadmap");
            applyMapTypeForZoom();

            if (setMapInstance) {
                setMapInstance(map); // Save for parent (smart search zoom)
            }
        }}
        >
          {markerPosition && <MarkerF position={markerPosition}></MarkerF>}
      </GoogleMap>
    </>
    
  );
};

export default MapViewer;